import { UserRolesEnum } from '@collections/users/enums/user-roles.enums';
import { Routes, UrlSegment } from '@angular/router';
import { ToolbarMode } from '@fuse/types/fuse-config';
// libs

// import { AuthGuard } from '@shared/auth/auth.guard';
// import { RoleGuard } from '@shared/auth/role.guard';

// nota: in canactivate, a differenza della documentazioen ufficiale, metto una stringa e uso UseClass nel provider
// questo perché lato server registro le routes, già localizzate con il localize-router, nello statetransfer
// così da averle già pronte lato client,
// ma inserendo la classe direttamente non verrebbe salvata come stringa nello stateTransfer ma come null
// da valutare in seguito se è una strada percorribile o se bisogna trovarne un'altra.

export const AppRoutes: Routes = [
  {
    path: 'administration/companies',
    loadChildren: () => import('./main/administration/companies-manager/companies-manager.module').then(m => m.CompaniesModule),
    data: { roles: [UserRolesEnum.admin] },
    canLoad: ['RoleGuard']
  }, {
    path: 'administration/news-manager',
    loadChildren: () => import('./main/administration/news-manager/news-manager.module').then(m => m.NewsManagerModule),
    data: { roles: [UserRolesEnum.admin] },
    canLoad: ['RoleGuard']
  }, {
    path: 'administration/newsletter-manager',
    loadChildren: () => import('./main/administration/newsletter-manager/newsletter-manager.module').then(m => m.NewsletterManagerModule),
    data: { roles: [UserRolesEnum.admin] },
    canLoad: ['RoleGuard']
  },{
    path: 'administration/wikis-manager',
    loadChildren: () => import('./main/administration/wikis-manager/wikis-manager.module').then(m => m.WikisManagerModule),
    data: { roles: [UserRolesEnum.admin] },
    canLoad: ['RoleGuard']
  }, {
    path: 'administration/log-viewer',
    loadChildren: () => import('./main/administration/log-viewer/log-viewer.module').then(m => m.LogViewerModule),
    data: { roles: [UserRolesEnum.admin] },
    canLoad: ['RoleGuard']
  }, {
    path: 'openid-login',
    loadChildren: () => import('./shared/auth/auth-components/openid-login/openid-login.module').then(m => m.OpenidLoginModule),
    data: { hideToolbar: true }
  }, {
    path: 'administration/requests-manager',
    loadChildren: () => import('./main/administration/requests-manager/requests-manager.module').then(m => m.RequestsManagerModule),
    data: { roles: [UserRolesEnum.admin] },
    canLoad: ['RoleGuard']
  }, {
    path: 'administration/categories-manager',
    loadChildren: () => import('./main/administration/categories-manager/categories-manager.module').then(m => m.CategoriesManagerModule),
    data: { roles: [UserRolesEnum.admin] },
    canLoad: ['RoleGuard']
  }, {
    path: 'administration/users-manager',
    loadChildren: () => import('./main/administration/users-manager/users-manager.module').then(m => m.UsersManagerModule),
    data: { roles: [UserRolesEnum.admin] },
    canLoad: ['RoleGuard']
  }, {
    path: 'administration/keyPI',
    loadChildren: () => import('./main/administration/keyPI/keyPI.module').then(m => m.KeyPIModule),
    data: { roles: [UserRolesEnum.admin] },
    canLoad: ['RoleGuard']
  },
  {
    path: 'pre-register',
    loadChildren: () => import('./main/authentication/pre-register/pre-register.module').then(m => m.PreRegisterModule),
    data: { hideToolbar: true }
  },
  {
    path: 'register',
    loadChildren: () => import('./main/authentication/register/register.module').then(m => m.UserRegisterModule),
    data: { hideToolbar: true }
  }, {
    path: 'login',
    loadChildren: () => import('./main/authentication/login/login.module').then(m => m.UserLoginModule),
    data: { hideToolbar: true }
  }, {
    path: 'registration-complete',
    loadChildren: () => import('./main/authentication/registration-complete/registration-complete.module').then(m => m.RegistrationCompleteModule),
  }, {
    path: 'reset-password/:token',
    loadChildren: () => import('./main/authentication/login/login.module').then(m => m.UserLoginModule),
    data: { hideToolbar: true },
  }, {
    path: 'account',
    loadChildren: () => import('./main/administration/users/user-account/user-account.module').then(m => m.UserAccountModule),
    // canActivate: ['AuthGuard']
  }, {
    path: 'account/:userSlug/edit/:lang',
    loadChildren: () => import('./main/administration/users/user-account/profile-editor/profile-editor.module').then(m => m.ProfileEditorModule),
    data: { roles: [UserRolesEnum.basic] },
    canActivate: ['UserGuard']
  }, {
    path: 'online-fair',
    loadChildren: () => import('./main/pages/home/home.module').then(m => m.HomeModule),
    data: {
      isCacheable: true,
      preload: true,
      toolbarMode: ToolbarMode.both
    }
  }, {
    path: 'news',
    loadChildren: () => import('./main/pages/news/news.module').then(m => m.NewsModule),
    data: {
      isCacheable: true,
      preload: false,
      toolbarMode: ToolbarMode.both
    }
  }, {
    path: 'products',
    loadChildren: () => import('./main/pages/products/products-page.module').then(m => m.ProductsPageModule),
    data: {
      isCacheable: true,
      preload: true,
      toolbarMode: ToolbarMode.solid //change to both when 'ready' with headers
    }
  }, {
    path: 'events',
    loadChildren: () => import('./main/pages/portal-events/portal-events.module').then(m => m.PortalEventsModule),
    data: {
      isCacheable: true,
      preload: false,
      toolbarMode: ToolbarMode.both
    }
  }, {
    path: 'events/edit',
    loadChildren: () => import('./portal-events/edit-portal-events/edit-portal-events.module').then(m => m.EditPortalEventsModule),
    data: { roles: [UserRolesEnum.admin] },
    canLoad: ['RoleGuard']
  }, {
    path: 'search',
    loadChildren: () => import('./main/pages/search-results/search-results.module').then(m => m.SearchResultsModule),
    data: {
      isCacheable: true,
      preload: false
    }
  }, {
    path: 'history',
    loadChildren: () => import('./main/pages/history/history.module').then(m => m.HistoryModule),
    data: {
      isCacheable: true,
      preload: false
    }
  }, {
    path: 'contacts',
    loadChildren: () => import('./main/pages/contacts/contacts.module').then(m => m.ContactsModule),
    data: {
      isCacheable: true,
      preload: false
    }
  }, {
    path: 'team',
    loadChildren: () => import('./main/pages/team/team.module').then(m => m.TeamModule),
    data: {
      isCacheable: true,
      preload: false
    }
  }, {
    path: 'careers',
    loadChildren: () => import('./main/pages/careers/careers.module').then(m => m.CareersModule),
    data: {
      isCacheable: true,
      preload: false
    }
  }, {
    path: 'testimonials',
    loadChildren: () => import('./main/pages/testimonials/testimonials.module').then(m => m.TestimonialsModule),
    data: {
      isCacheable: true,
      preload: false
    },
  }, {
    path: 'companies-list',
    loadChildren: () => import('./main/pages/companies-list/companies-list.module').then(m => m.CompaniesListModule),
    data: {
      isCacheable: true,
      preload: false
    },
  }, {
    path: 'metal-working-basics',
    loadChildren: () => import('./main/pages/metal-working-basics/metal-working-basics.module').then(m => m.MetalWorkingBasicsModule),
    data: {
      isCacheable: true,
      preload: false
    },
  }, {
    path: 'newsletter-viewer',
    loadChildren: () => import('./main/pages/newsletter-viewer/newsletter-viewer.module').then(m => m.NewsletterViewerModule),
    data: {
      isCacheable: true,
      preload: false
    },
  }, {
    path: 'hall/:category/:subcategory/stand',
    loadChildren: () => import('./stand/stand.module').then(m => m.StandModule),
    data: {
      isCacheable: true,
      preload: false,
      breadcrumb: 'hall'
    }
  }, {
    path: 'hall/:category/stand',
    loadChildren: () => import('./stand/stand.module').then(m => m.StandModule),
    data: {
      isCacheable: true,
      preload: false,
      breadcrumb: 'hall'
    }
  }, {
    matcher: (url) => {
      if (url.length < 5) {
        return null;
      }
      const regex = /\/hall(?:\/([a-z0-9-]*))?\/([a-z0-9-]*)\/(?:stand-free|stand)\/([a-z0-9-]*)\/edit/;
      const path: string = url.reduce((acc, v) => acc + '/' + v.path, '');
      const match: string[] = path.match(regex);
      const segments = match && match.length > 0 ?
      {
        consumed: url.slice(0).filter((v,i,arr) => v.path === 'edit' ? arr.splice(i) && true : true),
        posParams: {
          category: new UrlSegment(match[1] ? match[1] : match[2], {}),
          subcategory: new UrlSegment(match[1] ? match[2]: null, {}),
          companySlug: new UrlSegment(match[3], {})
        }
      } : null;
      return segments
    },
    loadChildren: () => import('./stand-administration/stand-administration.module').then(m => m.StandAdministrationModule)
  },
  {
    path: 'hall/:category/stand-free',
    loadChildren: () => import('./stand-free/stand-free.module').then(m => m.StandFreeModule),
    data: {
      isCacheable: true,
      preload: false,
      breadcrumb: 'hall'
    }
  }, {
    path: 'hall/:category/:subcategory/stand-free',
    loadChildren: () => import('./stand-free/stand-free.module').then(m => m.StandFreeModule),
    data: {
      isCacheable: true,
      preload: false,
      breadcrumb: 'hall'
    }
  },
  {
    path: 'hall',
    loadChildren: () => import('./main/pages/hall/hall.module').then(m => m.HallModule),
    data: {
      toolbarMode: ToolbarMode.transparent
    }
  }
  // , {
  //   path: 'orders-board',
  //   loadChildren: () => import('./main/orders/orders-board/orders-board.module').then(m => m.OrdersBoardModule),
  //   data: {
  //     isCacheable: true,
  //     preload: false
  //   }
  // }
  , {
    path: 'join-now',
    loadChildren: () => import('./main/pages/join-now/join-now.module').then(m => m.JoinNowModule),
    data: {
      isCacheable: true,
      preload: false
    }
  }, {
    path: 'online-fair-hall',
    loadChildren: () => import('./main/pages/online-fair-hall/online-fair-hall.module').then(m => m.OnlineFairHallModule),
    data: {
      isCacheable: true,
      preload: false
    }
  }, {
    path: 'sustainability',
    loadChildren: () => import('./main/pages/sustainability/sustainability.module').then(m => m.SustainabilityModule),
    data: {
      isCacheable: true,
      preload: false
    }
  },
  {
    path: 'solidarity',
    loadChildren: () => import('./main/pages/solidarity/solidarity.module').then(m => m.SolidarityModule),
    data: {
      isCacheable: true,
      preload: false
    }
  },
  {
    path: 'place-order',
    loadChildren: () => import('./main/orders/place-order/place-order.module').then(m => m.PlaceOrderModule),
    data: {
      isCacheable: true,
      preload: false
    }
  }, {
    path: 'privacy',
    loadChildren: () => import('./main/pages/privacy/privacy.module').then(m => m.PrivacyModule),
    data: {
      isCacheable: true,
      preload: false
    }
  }, {
    path: 'terms',
    loadChildren: () => import('./main/pages/terms/terms.module').then(m => m.TermsModule),
    data: {
      isCacheable: true,
      preload: false
    }
  },
  {
    path: 'sponsor',
    loadChildren: () => import('./main/pages/sponsor/sponsor.module').then(m => m.SponsorModule),
    data: {
      isCacheable: true,
      preload: false
    }
  }, {
    path: 'newsletter-complete',
    loadChildren: () => import('./main/pages/newsletter-complete/newsletter-complete.module').then(m => m.NewsletterCompleteModule),
  }
  // , {
  //   path: 'test',
  //   loadChildren: () => import('./main/pages/test/test.module').then(m => m.TestModule),
  //   data: {
  //     isCacheable: false
  //   }
  // }
  , {
    path: '', redirectTo: '/online-fair', pathMatch: 'full'
  }, {
    path: 'error',
    loadChildren: () => import('./error-handler/error-page/error-page.module').then(m => m.ErrorPageModule)
  }, {
    path: 'editor/preview',
    loadComponent: () => import('./shared/mat-editor/preview-dialog/editor-preview/editor-preview.component').then(mod => mod.EditorPreviewComponent),
    data: { hideToolbar: true },
  }, {
    path: '**', redirectTo: '/error/404', pathMatch: 'full'
  }
];
